export var getCurrencyCode = function (payRatesCurrency, payModifiers) {
    var _a, _b;
    if (!!payRatesCurrency) {
        return payRatesCurrency;
    }
    var currencyCode = (_b = (_a = payModifiers === null || payModifiers === void 0 ? void 0 : payModifiers.find(function (payModifier) { var _a; return !!((_a = payModifier.applicableNetAmount) === null || _a === void 0 ? void 0 : _a.code); })) === null || _a === void 0 ? void 0 : _a.applicableNetAmount) === null || _b === void 0 ? void 0 : _b.code;
    return currencyCode || 'USD';
};
